export const USER_SYSTEM_ERROR_CODES =  {
	ACCOUNT_NOT_FOUND : "ACCOUNT_NOT_FOUND",
	LICENSE_EXPIRED : "LICENSE_EXPIRED",
	ACCOUNT_REVOKED : "ACCOUNT_REVOKED",
	INVALID_LICENSE : "INVALID_LICENSE",
	NO_LICENSE : "NO_LICENSE",
	NO_TOKEN: "NO_TOKEN",
	AUTH_FAILED: "AUTH_FAILED"
};
